// src/components/gestionEvento/PruebasForm.js
import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  Paper,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import PruebasManager from '../Ajustes/Pruebas/PruebasManager';
import PruebasTab from './PruebasTab';
import CategoriasManager from './Categorias/CategoriasManager';

const PruebasForm = ({ competencia }) => {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleChange = (_e, newValue) => setValue(newValue);

  // Sin hack de full-bleed: el contenedor padre remueve padding/borde en móvil

  return (
    <Box sx={{ width: '100%' }}>
        {/* Header */}
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: 800, letterSpacing: 0.2, mb: 0.5 }}
          >
            Categorías y Pruebas
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Gestiona categorías, orden y detalles; y configura las pruebas de tu competencia.
          </Typography>
        </Box>

        {/* Tabs container con estilo “pill” */}
        <Box
          sx={{
            position: 'sticky',
            top: 0, // se adhiere al tope del contenedor/viewport
            zIndex: theme.zIndex.appBar,
            pb: 1.5,
            pt: 0.5,
            background: `linear-gradient(180deg, ${theme.palette.background.default} 70%, ${alpha(
              theme.palette.background.default,
              0
            )} 100%)`,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              px: { xs: 0.75, sm: 1 },
              py: 0.5,
              borderRadius: 999,
              display: 'inline-flex',
              border: `1px solid ${alpha(theme.palette.text.primary, 0.12)}`,
              bgcolor: alpha(theme.palette.background.paper, 0.8),
              backdropFilter: 'blur(6px)',
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Tabs de Categorías y Pruebas"
              variant={isMobile ? 'scrollable' : 'standard'}
              scrollButtons={isMobile ? 'auto' : false}
              TabIndicatorProps={{
                sx: {
                  height: '100%',
                  borderRadius: 999,
                  zIndex: -1,
                  backgroundColor: alpha(theme.palette.primary.main, 0.12),
                },
              }}
              sx={{
                minHeight: 44,
                '& .MuiTabs-flexContainer': { gap: 0.5 },
              }}
            >
              <Tab
                label="Categorías"
                sx={{
                  minHeight: 40,
                  textTransform: 'none',
                  fontWeight: 700,
                  px: { xs: 1.5, sm: 2.25 },
                  borderRadius: 999,
                  color: 'text.secondary',
                  '&.Mui-selected': {
                    color: theme.palette.primary.main,
                  },
                }}
              />
              <Tab
                label="Pruebas"
                sx={{
                  minHeight: 40,
                  textTransform: 'none',
                  fontWeight: 700,
                  px: { xs: 1.5, sm: 2.25 },
                  borderRadius: 999,
                  color: 'text.secondary',
                  '&.Mui-selected': {
                    color: theme.palette.primary.main,
                  },
                }}
              />
            </Tabs>
          </Paper>
        </Box>

        {/* Paneles */}
        <Box
          sx={{
            mt: 2,
            background: alpha(theme.palette.background.paper, 0.6),
            border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
            borderRadius: { xs: 0, md: 3 },
            boxShadow: `0 6px 24px ${alpha(theme.palette.common.black, 0.06)}`,
            overflow: 'hidden',
          }}
        >
          <PruebasTab value={value} index={0}>
            <Box sx={{ p: { xs: 1.5, sm: 2, md: 2.5 } }}>
              <CategoriasManager competencia={competencia} />
            </Box>
          </PruebasTab>

          <PruebasTab value={value} index={1}>
            <Box sx={{ p: { xs: 1.5, sm: 2, md: 2.5 } }}>
              <PruebasManager competencia={competencia} />
            </Box>
          </PruebasTab>
        </Box>
      </Box>
  );
};

export default PruebasForm;
